import { Component, Input, OnInit, Output, ViewChild,EventEmitter } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';

@Component({
  selector: 'app-new-open-branch-chart',
  templateUrl: './new-open-branch-chart.component.html',
  styleUrls: ['./new-open-branch-chart.component.scss']
})
export class NewOpenBranchChartComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;
  @Input() chartOptionsList: any;
  @Input() loading: boolean;

  constructor() {
  }

  ngOnInit(): void {
    console.log('list' + this.chartOptionsList)
  }

}
